import React from 'react';
import SocialIcons from '../Footer/SocialIcons';
import { LinkV2 } from '../LinkV2';
import ZolaLogo from '../ZolaLogo';
import {
  ActionLinksWrapper,
  AppLinkWrapper,
  ButtonsWrapper,
  GetStartedButton,
  SocialsWrapper,
  StyledH5,
  ZolaInfoWrapper,
} from './PreAuthFooterV3ZolaInfo.styles';
import appStoreBadge from '../../assets/images/footer/app-store-badge.svg';

export type PreAuthFooterV3ZolaInfoProps = {
  isGuest: boolean;
};

const PreAuthFooterV3ZolaInfo = ({ isGuest = true }: PreAuthFooterV3ZolaInfoProps): JSX.Element => {
  return (
    <ZolaInfoWrapper>
      <ZolaLogo color="#0E0E0E" />
      <StyledH5>For all the days along the way</StyledH5>
      <ActionLinksWrapper>
        {isGuest ? (
          <LinkV2 arrow href="/account/login">
            Log in
          </LinkV2>
        ) : null}
        <LinkV2 arrow href="/search/wedding-registry">
          Find a couple
        </LinkV2>
        <LinkV2 arrow href="https://baby.zola.com/search/baby-registry">
          Find a baby registry
        </LinkV2>
      </ActionLinksWrapper>
      <ButtonsWrapper>
        {isGuest ? (
          <GetStartedButton component="a" href="/wedding/onboard/wedding-planning">
            Get started
          </GetStartedButton>
        ) : null}
        <AppLinkWrapper>
          <LinkV2
            href="https://itunes.apple.com/us/app/zola-wedding-registry-gifts/id852691916"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={appStoreBadge} alt="Download On The App Store" loading="lazy" />
          </LinkV2>
        </AppLinkWrapper>
      </ButtonsWrapper>
      <SocialsWrapper>
        <SocialIcons />
      </SocialsWrapper>
    </ZolaInfoWrapper>
  );
};

export default PreAuthFooterV3ZolaInfo;
